import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

const STYLES = {
  COMPLIANT: "bg-emerald-50 text-emerald-600 border-emerald-200",
  ACTION_REQUIRED: "bg-amber-50 text-amber-600 border-amber-200",
  CRITICAL: "bg-red-50 text-red-600 border-red-200",
  INCOMPLETE: "bg-slate-100 text-slate-600 border-slate-300",
};

export function ComplianceBadge({ status, className }) {
  const { t } = useTranslation();
  const cls = STYLES[status] || STYLES.INCOMPLETE;
  return (
    <span
      data-testid={`compliance-badge-${status}`}
      className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wider", cls, className)}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {t(`status.${status}`, status)}
    </span>
  );
}

const EMP_STATUS_STYLES = {
  active: "bg-emerald-50 text-emerald-600 border-emerald-200",
  freistellung: "bg-amber-50 text-amber-700 border-amber-200",
  terminated: "bg-red-50 text-red-600 border-red-200",
};

export function EmploymentBadge({ status }) {
  const { t } = useTranslation();
  const s = status || "active";
  const label = { active: t("det.esActive"), freistellung: t("det.esFreistellung"), terminated: t("det.esTerminated") }[s] || s;
  return (
    <span data-testid={`employment-badge-${s}`}
      className={cn("inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider", EMP_STATUS_STYLES[s] || EMP_STATUS_STYLES.active)}>
      {label}
    </span>
  );
}

export function PortalBadge({ status }) {
  const { t } = useTranslation();
  const map = {
    ACTIVE: "bg-emerald-50 text-emerald-600 border-emerald-200",
    INVITATION_PENDING: "bg-cyan-50 text-cyan-dark border-cyan-200",
    DISABLED: "bg-red-50 text-red-600 border-red-200",
    NOT_INVITED: "bg-slate-100 text-slate-500 border-slate-200",
  };
  return (
    <span className={cn("inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider", map[status] || map.NOT_INVITED)}>
      {t(`portalStatus.${status}`, status)}
    </span>
  );
}
